import React from 'react';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';

/**
 * A reusable 3D module component that renders a 3D model at a specified position.
 * 
 * @param {object} props 
 * @param {array} props.position - The 3D position of the module [x, y, z]
 * @param {function} props.func - The function that returns the 3D model
 * @returns {ReactElement} A 3D module component
 * @example
 * <Module3D position={[10, 20, 30]} func={Rack9slot} />
 */
const Module3D = ({ position, func }) => {
  return (<>{func(position)}</>);
};

/**
 * A 3D view component that renders a collection of 3D modules and a rack model.
 * 
 * @param {object} props.selectedModules - An object containing the selected modules and rack model
 * @param {array} props.selectedModules.modules - An array of module objects with func properties
 * @param {function} props.selectedModules.rackModel - The function that returns the rack model
 * @returns {ReactElement} A 3D view component
 
 */

const Model3DView = ({ selectedModules }) => {
  const { rackModel, modules } = selectedModules;

  return (
    <>
      <PerspectiveCamera makeDefault position={rackModel.name === '9-slot' ? [122, 0, 600] : rackModel.name === '14-slot' ? [200, 0, 600] : [80, 0, 600]} />
      <OrbitControls target={rackModel.name === '9-slot' ? [122, 0, 0] : rackModel.name === '14-slot' ? [200, 0, 0] : [80, 0, 0]} />

      {rackModel && rackModel.slots.map((slotName, index) => {
        const module = modules[slotName];
        if (!module) return null;

        return (
          <Module3D
            key={slotName}
            position={[30.5 * index + 0.1, -8.8, 12.3]}
            func={module.func}
          />
        );
      })}

      <mesh>
        {rackModel.model()}
      </mesh>


      <directionalLight args={[0xffffff, 3.5]} position={[0, 1, 3]} />
    </>
  );
};

export default Model3DView;